"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
/* eslint-disable */
/* tslint:disable */
var React = tslib_1.__importStar(require("react"));
var Facebook = function (_a) {
    var size = _a.size, props = tslib_1.__rest(_a, ["size"]);
    return (React.createElement("svg", tslib_1.__assign({ viewBox: "0 0 22 22", fill: "currentColor", width: size || "22", height: size || "22" }, props),
        React.createElement("path", { d: "M14 7.826h-1.087c-.853 0-1.019.386-1.019.952v1.249h2.035l-.266 1.956h-1.769V17h-2.12v-5.017H8v-1.956h1.773V8.585C9.773 6.911 10.847 6 12.415 6c.751 0 1.397.053 1.585.077v1.749zM11 0C4.925 0 0 4.925 0 11s4.925 11 11 11 11-4.925 11-11S17.075 0 11 0z", fillRule: "evenodd" })));
};
Facebook.displayName = 'Facebook';
exports.default = Facebook;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=Facebook.js.map